import React from "react";

// Decorative SVG balloon
export const Balloon = ({ color = "#FF729F", highlight = "#FFD7E3", size = 80, className = "", style = {} }) => (
  <svg
    viewBox="0 0 80 110"
    width={size}
    height={(size * 110) / 80}
    className={className}
    style={style}
    aria-hidden="true"
  >
    <defs>
      <radialGradient id={`g-${color.replace("#", "")}`} cx="35%" cy="30%" r="60%">
        <stop offset="0%" stopColor={highlight} stopOpacity="1" />
        <stop offset="55%" stopColor={color} stopOpacity="1" />
        <stop offset="100%" stopColor={color} stopOpacity="0.9" />
      </radialGradient>
    </defs>
    <ellipse cx="40" cy="42" rx="32" ry="38" fill={`url(#g-${color.replace("#", "")})`} />
    <path d="M36 80 L40 88 L44 80 Z" fill={color} opacity="0.85" />
    <path
      d="M40 88 C 38 94, 44 98, 40 104 C 36 108, 44 110, 40 110"
      stroke={color}
      strokeWidth="1.2"
      fill="none"
      opacity="0.55"
    />
    <ellipse cx="30" cy="28" rx="5" ry="7" fill="white" opacity="0.55" />
  </svg>
);

export const Confetti = ({ color = "#FFC857", size = 18, className = "", style = {} }) => (
  <svg
    viewBox="0 0 20 20"
    width={size}
    height={size}
    className={className}
    style={style}
    aria-hidden="true"
  >
    <rect x="8" y="2" width="4" height="16" rx="1" fill={color} transform="rotate(20 10 10)" />
  </svg>
);

export const Star = ({ color = "#FFC857", size = 22, className = "", style = {} }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} className={className} style={style} aria-hidden="true">
    <path
      d="M12 2l2.39 6.95H22l-6.17 4.48L18.18 22 12 17.77 5.82 22l2.35-8.57L2 8.95h7.61z"
      fill={color}
    />
  </svg>
);
